import { PlanShap } from 'src/app/features/floor-plan/models/Plan-Shaps';
import { Currency, Lookup } from 'src/app/models/Lookup';

export enum FloorViewerType {
  ContentView = 0,
  TimeView = 1,
  AssignedServer = 2
}
export class ListData {
  pageIndex!: number;
  totalCount!: number;
  totalCancelled!: number;
  totalCompleted!: number;
  totalNoShow!: number;
  totalOngoing!: number;
  totalUpcomming!: number;
  totalWaitingList!: number;
  totalAll!: number;
  pageSize!: number;
  userType!: string;
  canAdd!: boolean
  isOwner!: boolean
  isWaiter!: boolean

  pageData!: {
    totalPartySize: number
    reservationTime: string
    reservationDate: string
    pageData: {
      id: number
      canEdit: boolean
      canEditTable: boolean
      reservationDate: string
      reservationNumber: number
      tableName: string
      partySize: number
      guestName: string
      status: ReservationStatusEnum
      restaurant: Restaurant
      reservationTimeFrom: string
      reservationTimeTo: string
      timeInterval: string
      customer: ReservationGuest
      hasPreferences: boolean
      reservationChanel: string
      cancellationBytype: CancellationBytype
      reservationType: ReservationTypeEnum
      refund: string
      lastOrderPaid: boolean
      ordersList: {
        id: number
        orderNumber: number
      }[]
    }[]
  }[];
}

export class Restaurant {
  icon!: string;
  id!: number;
  nameAr!: string;
  nameEn!: string;
}
export class ReservationGuest {
  customerId!: number
  email!: string
  fName!: string
  lName!: string
  phoneflag!: string
  phoneCode!: string
  phoneNumber!: string
  isBlackList!: boolean
  isSuspend!: boolean
  tagsList!: Lookup[]
  userId!: string
  icon!: string
  customerPoints!: {
    expierdPoint: any
    isEnabled: boolean
    pointInCountry: number
    restaurantName: string
    totalPoint: number
  }
}
export class Record {
  announcementId!: number;
  iconAnnouncement!: string;
  nameAnnouncement!: string;
  typeAnnouncement!: string;
  dateAnnouncement!: string;
  timeAnnouncementFrom!: string;
  timeAnnouncementTo!: string;
  branchName!: string;
  howCreatedAnnouncement!: number;
}
export class ListFilter {
  pageSize!: number;
  pageNumber!: number;
  searchText!: string;
  announcementStuts!: number
  sortItems!: number
  dateTo!: Date;
  dateFrom!: Date;
  timeTo!: Date;
  timeFrom!: Date;
  minVists!: number;
  maxVists!: number;
  restaurantID!: number;
}
export enum reservationType {
  All = 0,
  Upcoming = 1,
  Ongoing = 2,
  Completed = 3,
  Cancelled = 4,
  Waiting = 5,
  NoShow = 6
}
export enum sortList {
  NewestReservation = 0,
  OldestReservation = 1
}
export class Floor {
  id!: number
  name!: string
  tabels!: FloorItem[]
}
export interface FloorItem extends PlanShap {
  id: number
  name: string
  selected: boolean
  recommended: boolean
  currentReservations: TableReservations | null
  tableStatus: TabelStatusEnum
  tableReservations: TableReservations[]
  tableWaiters: Waiter[]
  canBlockAndUnBlockTable: boolean
  canReserveTable: boolean
}
export class Waiter {
  id!: number
  name!: string
  profilePic!: string
  isSelected!: boolean
  tabelsCount!: number
  reservationCount!: number
  tabelsNames!: string
}
export class TableReservations {
  id!: number
  customerName!: string
  customerProfilePic!: string
  reservationStatus!: ReservationStatusEnum
  reservationDate!: string
  reservationTimeFrom!: string
  reservationTimeto!: string
  isActiveNow!: boolean
  waitersList!: Waiter[]
}
export enum ReservationStatusEnum {
  Reserved = 'Reserved',
  Arrived = 'Arrived',
  Seated = 'Seated',
  Released = 'Released',
  Cancelled = 'Cancelled',
  NoShow = 'NoShow'
}
export enum ReservationTypeEnum {
  Scheduled = 'Scheduled',
  WalkIn = 'WalkIn',
  WaitingList = 'WaitingList',
  Event = 'Event',
  ReservedNow = 'ReservedNow'
}
export enum TabelStatusEnum {
  Free = 'Free',
  Blocked = 'Blocked',
  Reserved = 'Reserved',
}
export class ReservationForm {
  reservationId!: number
  restaurantsId!: number
  reservationType!: ReservationTypeEnum
  reservationchannelId!: number
  partySize!: number
  reservationDate!: string | Date
  reservationTimeFrom!: string|null
  reservationTimeTo!: string|null
  reservationDuration!: string
  amenities!: number[]
  seatings!: number[]
  specialRequest!: string
  floorId?: number
  tabels!: number[]
  reserveAnyWay!: boolean
  customer?: ReservationGuest
  tagsList!: Lookup[]
}
export class ChangeReservationTable {
  reservationId!: number
  floorId!: number
  tabels!: number[]
  reserveAnyWay!: boolean
}
export class ReservationFormResponse {
  canReserveAnyWay!: boolean
  checkRecommendation!: string[]
  checkresult!: string[]
  reservationId!: number
  result!: {
    code: number
    errorMessages: string[]
    success: boolean
  }
  tabelsRecommendation!: number[]
  canPlasedOrder!: boolean
}

export class Filter {
  createdFrom!: Date;
  createdTo!: Date;
  restaurantId!: number;
  pageNumber!: number;
  pageSize!: number;
  sort!: number
  status!: number
  reservationDate!: string
  partySizeFrom!: number
  partySizeTo!: number
  searchText!: string
  cancelStatus!: string
  ongoingStatus!: string
  reservationType!: string
}


export class ReservationDetails {
  reservationType!: ReservationTypeEnum
  reservationDate!: string;
  tableName!: string;
  partySize!: number
  eventName!: string
  isDeletedEvent!: boolean
  restaurantId!: number
  restaurantNameEN!: string;
  restaurantNameAR!: string;
  restaurantIcon!: string;
  reservationNumber!: string;
  reservationChannel!: Lookup;
  reservationDuration!: any
  reservationPrefrences!: string;
  specialRequest!: string;
  assignedName!: string;
  assignedIcon!: string;
  guestName!: string;
  guestTags!: string;
  guestIcon!: string;
  phone!: string;
  phoneCode!: string;
  phoneFlag!: string;
  email!: string;
  canArrived!: boolean
  canSeated!: boolean
  canCancelled!: boolean
  canNoShow!: boolean
  canReleased!: boolean
  canEdit!: boolean
  canExtendDuration!: boolean
  canPlaceOrder!: boolean
  customer!: ReservationGuest
  tabels!: number[]
  floorId!: number
  seatings!: number[]
  amenities!: number[]
  reservationTimeFrom!: string
  reservationTimeTo!: string
  event!: Lookup
  selectedSlots!: Lookup[]
  currentUserRoles!: Roles[]
  waitersList!: Waiter[]
  canEditWaiter!: boolean
  canEditTable!: boolean
  orderDetails?: orderDetails[] | null
}

export class orderDetails {
  canCancel!: boolean
  canEdit!: boolean
  orderNumber!: number
  currency!: Currency
  orderId!: number
  orderStatus!: string
  orderItems!: orderItems[]
  discountName!: string
  discountValue!: number
  serviceValue!: number
  surchargeValue!: number
  canManageDiscount!: boolean
  canManageSurcharge!: boolean
  canPaymentDetails!: boolean
  canCheckout!: boolean
  subTotal!: number
  taxValue!: number
  total!: number
  paymentDetails!: any[]

  editMode!: boolean
  orderNotes!: string
}

export class orderItems {
  itemsCount?: number
  calories?: number
    canDelete?: boolean
    canEdit?: boolean
    curruncyName?: string
    description?: string
    id: any
    itemName?: string
    itemPic?: string
    itemSize?: any
    itemSizes: any
    kitchenId: any
    kitchenName?: string
    menuItemId: any
    preparationTime?: string
    currentPreparationTime?: number
    preparingTimer: any
    price?: number
    totalItemprice?: number
    count?: number
    canDirectAdd?: boolean
    quantity?: number
    paidQuantity?: number
    minQuantity?: number
    rate?: number
    restaurantSizeId?: number
    sizeName?: string
    specialRequest?: string
    status?: string
    statusPermissions: any
    unWantedOptionalIngredients: any
    priceByPiece?: number;
    isFree?: boolean;
    freeQuantity?: number;
    optionalIngredients?: {
      icon: string
      id: number
      isavailable: boolean
      name: string
    }[]
    unWantedOptionIngrediant?: {
      icon: string
      id: number
      isavailable: boolean
      name: string
    }[]
    additions?: {
      id: any
      name: string
      itemAdditionlist: {
        id: number
        isSelected: boolean
        name: string
      }[]
    }[]
    additionsOptions: any
    variantsOptions: any
    mainIngredients?: {
      icon: string
      id: number
      isSelected: boolean
      name: string
    }[]
    variants?: {
      id: any
      name: string
      itemVariantlist: {
        id: number
        isSelected: boolean
        name: string
      }[]
    }[]
}

export class changeStatus {
  restaurantId!: number
  reservationId!: number
  reservationStatus!: any
}

export enum CancellationBytype {
  System = 'System',
  Restaurant = 'Restaurant',
  Gust = 'Gust'
}

export class Roles {
  id!: any
  nameAr!: string
  nameEn!: string
  roleType!: string
}

export enum RoleType {
  Dynamic,
  RestaurantOwnerRole,
  RestaurantManagerRole,
  RestaurantChefRole,
  RestaurantResponsibleChefRole,
  RestaurantHost,
  RestaurantServer,
}


export enum OngoingStatusEnum {
  Arrived = 'Arrived',
  Seated = 'Seated',
}
export enum CancelStatusEnum {
  Cancelled = 'Cancelled',
  NoShow = 'NoShow',
}
